import React from 'react';
import styled from 'styled-components';
import SelectMenu from '@decisiv/ui-components/lib/components/SelectMenu';

const PERIODS = [
  { id: 'day', label: 'Last 24 hours' },
  { id: 'week', label: 'Last 7 days' },
  { id: 'month', label: 'Last 30 days' },
  { id: 'all', label: 'All Time' },
];

// SelectMenu renders its `label` prop as a plain <span> beside the trigger
// button, making the label text a non-interactive dead zone. Same fix as
// AdminFilters: pass label=" " and hide that span via CSS, so the button
// alone (showing the selected period) is the whole clickable control.
const Wrapper = styled.div`
  margin-bottom: 16px;

  & > div > span:first-child {
    display: none;
  }
`;

// Full-page navigation with a `?period=` query param — the controller
// re-renders fresh props, so no client-side fetch/state is needed here.
// `q`/`searchField`/`groupBy` (if present) are preserved across period
// switches.
const PeriodSelector = ({
  period,
  basePath,
  q = '',
  searchField = '',
  groupBy = '',
}) => (
  <Wrapper>
    <SelectMenu
      label=" "
      options={PERIODS}
      selected={period}
      size="small"
      onChange={(id) => {
        const params = new URLSearchParams({ period: id });
        if (groupBy) params.set('group_by', groupBy);
        if (q) {
          params.set('q', q);
          if (searchField) params.set('search_field', searchField);
        }
        window.location.href = `${basePath}?${params.toString()}`;
      }}
    />
  </Wrapper>
);

export default PeriodSelector;
